import { Bar, Doughnut } from 'react-chartjs-2';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from "../../modules";
import React, { Component } from "react";
import { Theme, WithStyles, WithTheme, createStyles, withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { loadAccounts } from '../../modules/accounts';
import { proxyBase } from '../../modules/config';
import { push } from "connected-react-router";

const styles = (theme: Theme) => createStyles({
  root: {
    height: '100%',
  },
  progress: {
    alignSelf: 'center',
    margin: '5rem auto',
  },
  summary: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  summaryPaper: {
    flex: '1 1 auto',
    padding: theme.spacing(3),
    cursor: 'pointer',
  },
  summaryTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing(1)
  },
  summaryAmount: {
    fontSize: '2rem',
    textAlign: 'center',
  },
  summaryGreen: {
    color: 'rgba(139,195,74,1)'
  },
  summaryRed: {
    color: 'rgba(244,67,54,1)'
  },
  chartPaper: {
    padding: theme.spacing(3),
    "& canvas": {
      width: '100% !important'
    }
  },
  recentTransactionPaper: {
    padding: theme.spacing(3)
  },
  bottomMargin: {
    marginBottom: theme.spacing(3)
  }
});


type State = {
};

class OverviewPane extends Component<Props, State> {
  componentDidMount = () => {
    const { loadAccounts } = this.props
    loadAccounts()

    document.title = "Account Overview"
  }

  renderAssetsChart = () => {
    const { accounts, classes } = this.props

    let monthStart = new Date().getMonth()

    let labels: string[] = []

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    for (let i = 1; i <= accounts.statistics.historical.assets.length; i++) {
      var d = new Date()
      d.setMonth(monthStart - i)
      labels.unshift(monthNames[d.getMonth()] + " " + d.getFullYear())
    }

    let usdBalance = accounts.list.map(a => a.currency === "USD" ? a.balance : 0)
    let cumulativeAssets = usdBalance.reduce((a, b) => a + b, 0)

    let assetData: number[] = [cumulativeAssets]
    for (let i = accounts.statistics.historical.assets.length - 1; i > 0; i--) {
      cumulativeAssets -= accounts.statistics.historical.assets[i]
      assetData.unshift(cumulativeAssets)
    }

    const data = {
      labels,
      datasets: [{
        label: "Savings",
        data: accounts.statistics.historical.out,
        type: "bar",
        backgroundColor: 'rgba(244,67,54,1)',
        borderColor: 'rgba(244,67,54,1)',
      }, {
        type: "line",
        label: "Total Assets",
        data: assetData,
        fill: true,
        backgroundColor: 'rgba(139,195,74,.1)',
        borderColor: 'rgba(139,195,74,1)',
      },],
    }
    const options = {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            stepSize: 10000
          },
          gridLines: {
            display: false
          }
        }],
        xAxes: [{
          gridLines: {
            display: false
          }
        }]
      },
      legend: {
        position: 'bottom',
      },
      maintainAspectRatio: true,
      responsive: true
    }

    return (
      <Paper className={classes.chartPaper}>
        <Typography variant="h4" className={classes.bottomMargin}>Savings &amp; Spendings</Typography>
        <Bar data={data} options={options} />
      </Paper>
    )
  }

  renderSpendingChart = () => {
    const { accounts, classes, theme } = this.props
    let backgroundColor: string[] = []

    let interval = 360 / accounts.statistics.spending.categories.length
    for (let i = 0; i < accounts.statistics.spending.categories.length; i++) {
      backgroundColor.push(`hsla(${interval * i} ,70%, 70%, 1)`)
    }

    const data = {
      labels: accounts.statistics.spending.categories,
      datasets: [{
        data: accounts.statistics.spending.amount,
        backgroundColor
      }]
    }
    return (
      <Paper className={classes.chartPaper}>
        <Typography variant="h4" className={classes.bottomMargin}>Recent Spending</Typography>
        <Doughnut data={data} options={{ legend: { position: theme.breakpoints.up('sm') ? 'right' : 'bottom' } }} />
      </Paper>
    )
  }

  renderRecentTransactions = () => {
    const { accounts, intl } = this.props

    return accounts.transactions.map((t, i) => {
      let date = new Date()
      date.setDate(date.getDate() + t.dateOffset)

      return <TableRow key={i}>
        <TableCell>{date.toLocaleDateString(intl.locale, { day: 'numeric', month: 'short' } as any)}</TableCell>
        <TableCell>{t.description}</TableCell>
        <TableCell align="right">{new Intl.NumberFormat(intl.locale, { style: 'currency', currency: "USD" }).format(t.amount)}</TableCell>
      </TableRow>
    })
  }

  render() {
    const { accounts, classes, intl, proxyBase } = this.props;

    let summaryGreen = accounts.list.map(a => a.currency === "USD" && a.balance > 0 ? a.balance : 0).reduce((a, b) => a + b, 0)
    let summaryRed = accounts.list.map(a => a.currency === "USD" && a.balance < 0 ? a.balance : 0).reduce((a, b) => a + b, 0)
    return (
      <Grid container spacing={1} className={classes.root}>
        <Grid item xs={6} className={classes.summary}>
          <Paper className={classes.summaryPaper} onClick={() => this.props.push(proxyBase('/pib/accounts'))}>
            <div className={classes.summaryTitle}>What you have:</div>
            <div className={classnames(classes.summaryAmount, classes.summaryGreen)}>{new Intl.NumberFormat(intl.locale, { style: 'currency', currency: "USD" }).format(summaryGreen)}</div>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper className={classes.summaryPaper} onClick={() => this.props.push(proxyBase('/pib/accounts'))}>
            <div className={classes.summaryTitle}>What you owe:</div>
            <div className={classnames(classes.summaryAmount, classes.summaryRed)}>{new Intl.NumberFormat(intl.locale, { style: 'currency', currency: "USD" }).format(summaryRed)}</div>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper className={classes.recentTransactionPaper}>
            <Typography variant="h4" className={classes.bottomMargin}>Recent Transactions</Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.renderRecentTransactions()}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          {this.renderAssetsChart()}
        </Grid>
        <Grid item xs={12}>
          {this.renderSpendingChart()}
        </Grid>
      </Grid >
    )
  }
}

const mapStateToProps = ({ accounts, intl }: IStoreState) => ({
  accounts,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      loadAccounts,
      push,
      proxyBase
    }, dispatch
  )

interface Props extends WithTheme, WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(OverviewPane));